import React, { useEffect, useState } from 'react';
import { Table, Spin, Button, Modal, Space, Tooltip } from 'antd';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { userMangement } from '../../redux/actions/authActions';
import { generatePaginationObj } from '../../utilities/helpers';
import AddMarketingUser from '../../components/marketingUser/addMarketingUser';
import BrandDetails from '../../components/marketingUser/brandsDetails';

function MarketingTeamDetails(props) {
  const { hasEditRole } = props;
  const [loading, setLoading] = useState(false);
  const [showUserModal, setShowUserModal] = useState({
    visible: false,
    data: null,
  });

  const [brandsDetailModal, setBrandsDetailModal] = useState({
    visible: false,
    data: null,
  });

  const [members, setMembers] = useState({
    data: [],
    pagination: {
      offset: 0,
      limit: 10,
      total: 0,
      current: 1,
    },
  });

  const toggleUserModal = (data = null) => {
    setShowUserModal({
      visible: !get(showUserModal, 'visible'),
      data,
    });
  };

  const toggleBrandDetailsModal = (data = null) => {
    setBrandsDetailModal({
      visible: !get(brandsDetailModal, 'visible'),
      data,
    });
  };

  const dispatch = useDispatch();

  const getMarketingTeam = (page = 1) => {
    setLoading(true);
    const pageObj = generatePaginationObj(
      page,
      get(members, 'pagination.limit')
    );
    dispatch(
      userMangement('list.marketing_users', {
        ...pageObj,
      })
    )
      .then((result) => {
        setLoading(false);
        setMembers({
          data: get(result, 'data', []),
          pagination: {
            ...pageObj,
            total: get(result, 'total'),
            current: page,
          },
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const refreshUserList = () => {
    getMarketingTeam();
  };

  useEffect(() => {
    getMarketingTeam();
  }, []);

  return (
    <div className="team-detail-container">
      <Spin spinning={loading}>
        {hasEditRole && (
          <div className="top-section">
            <Button className="default-btn" onClick={() => toggleUserModal()}>
              + Add Marketing User
            </Button>
          </div>
        )}

        <Table
          rowKey="id"
          columns={[
            {
              title: 'Member Name',
              key: 'name',
              dataIndex: 'name',
            },
            {
              title: 'Email',
              key: 'email',
              dataIndex: 'email',
            },
            {
              title: 'Responsibility',
              key: 'role',
              dataIndex: ['Role', 'name'],
            },
            {
              title: 'Brand Allocated',
              key: 'brand_allocated',
              align: 'center',
              dataIndex: ['brands_allocated'],
            },
            {
              title: 'Action',
              key: 'action',
              render: (record) => (
                <Space size="large">
                  {hasEditRole && (
                    <Tooltip title="Edit marketing user">
                      <EditOutlined
                        className="table-icon table-icon-color"
                        onClick={() => toggleUserModal(record)}
                      />
                    </Tooltip>
                  )}
                  <Tooltip title="View Brands details">
                    <PlusOutlined
                      className="table-icon table-icon-color"
                      onClick={() => toggleBrandDetailsModal(record)}
                    />
                  </Tooltip>
                </Space>
              ),
            },
          ]}
          dataSource={get(members, 'data')}
          pagination={{
            showSizeChanger: false,
            position: ['bottomCenter'],
            hideOnSinglePage: true,
            pageSize: get(members, 'pagination.limit'),
            total: get(members, 'pagination.total'),
            current: get(members, 'pagination.current'),
          }}
          onChange={(paginationObj) => {
            getMarketingTeam(get(paginationObj, 'current'));
          }}
        />

        <Modal
          width="55%"
          className="common-modal"
          destroyOnClose
          closable={false}
          open={get(showUserModal, 'visible')}
          onOk={toggleUserModal}
          onCancel={toggleUserModal}
          footer={null}
          maskClosable={false}
        >
          <AddMarketingUser
            showModal={get(showUserModal, 'visible')}
            refreshUserList={refreshUserList}
            onClose={toggleUserModal}
            edit={!!get(showUserModal, 'data')}
            initialValue={get(showUserModal, 'data')}
          />
        </Modal>

        <Modal
          width="45%"
          className="common-modal"
          destroyOnClose
          // closable={false}
          open={get(brandsDetailModal, 'visible')}
          onOk={toggleBrandDetailsModal}
          onCancel={toggleBrandDetailsModal}
          footer={null}
          maskClosable={false}
        >
          <BrandDetails
            brands={get(brandsDetailModal, 'data.UserCompanies')}
            onClose={toggleBrandDetailsModal}
          />
        </Modal>
      </Spin>
    </div>
  );
}

export default MarketingTeamDetails;
